<script>
import 'select2';
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'ajaxUrl': {
			type: String,
			required: false
		},
		'options': {
			type: Array,
			default: []
		},
		'placeholder': {
			type: String,
			required: false,
		},
		'currentValueLabel': {
			type: String,
			required: false,
		},
		'tags': {
			type: Boolean,
			default: false,
		},
		'multiple': {
			type: Boolean,
			default: false,
		}
	},
	methods: {
		initialiseSelect2() {
			let settings = {
				theme: 'bootstrap-5',
			}

			if (this.ajaxUrl) {
				settings['ajax'] = {
					url: this.ajaxUrl,
					dataType: 'json',
					delay: 200
				}
			}

			if (this.tags) {
				settings['tags'] = true;
			}

			if (this.placeholder) {
				settings['placeholder'] = this.placeholder;
			}

			if (this.placeholder && !this.multiple) {
				settings['allowClear'] = true;
			}

			let $select = $(this.$refs.select);
			if ($select.closest('.modal').length > 0) {
				settings['dropdownParent'] = $select.closest('.modal')[0];
			}

			$select.select2(settings);
		},

		isSelected(option) {
			if (Array.isArray(this.modelValue)) {
				return this.modelValue.includes(option.value) || this.modelValue.includes(`${option.value}`);
			}
			return option.value == this.modelValue
		},

		setModelValue(event) {
			let value = $(event.currentTarget).select2("val");
			let result = null;
			if (this.multiple) {
				result = [];
				for (let index in value) {
					result[index] = this.toNumericIfNeeded(value[index]);
				}
			} else {
				result = this.toNumericIfNeeded(value);
			}
			this.changeModelValueTo(result)
		},

		toNumericIfNeeded(value) {
			if (!isNaN(value)) {
				return value * 1;
			}
			return value;
		}
	},
	mounted() {
		this.initialiseSelect2();

		$(this.$refs.select).on('change', this.setModelValue.bind(this));

		this.$watch('modelValue', event => {
			$(this.$refs.select).select2('destroy');
			this.initialiseSelect2();
		});
	}
}
</script>

<template>
	<div v-memo="this.options" :class="{groupClasses: groupClasses, 'select-has-errors': hasError}">
		<select
			ref="select"
			:name="name"
			:id="renderedId"
			v-bind="$attrs"
			class="form-control"
			:multiple="multiple"
		>
			<option v-if="options.length < 1 && currentValueLabel && modelValue" :value="modelValue" selected>{{ currentValueLabel }}</option>
			<slot/>
			<option v-for="option in options" :selected="isSelected(option)" :value="option.value">{{ option.label }}</option>
		</select>
		<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
	</div>
</template>